import { PropsWithChildren } from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { store } from '@/redux/store';

import { FeatureFlagProvider } from './FeatureFlag';

type AppProviderProps = PropsWithChildren;

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <ReduxProvider store={store}>
      <FeatureFlagProvider>{children}</FeatureFlagProvider>
    </ReduxProvider>
  );
};
